export default {"src":"/_next/static/media/icon-judgement.3c6226cf.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};